const CrossCircleIcon = ({ className, title }) => (
  <svg
    aria-hidden={title ? undefined : 'true'}
    className={className}
    fill='none'
    height='23'
    role={title ? 'img' : undefined}
    viewBox='0 0 23 23'
    width='23'
    xmlns='http://www.w3.org/2000/svg'
  >
    {title && <title>{title}</title>}
    <circle
      cx='11.5'
      cy='11.5'
      r='10.75'
      stroke='#FF3152'
      strokeWidth='1.5'
    />
    <path
      d='M8 8L15 15M15 8L8 15'
      stroke='#FF3152'
      strokeLinecap='round'
      strokeWidth='1.5'
    />
  </svg>
)

export default CrossCircleIcon
